import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {ModalComponent} from "../modal/modal.component";
import { BsModalService } from 'ngx-bootstrap/modal';
import { HttpClient } from '@angular/common/http';
import {PodcastItem} from "../../../editor/podcast-item";
import {TranslationService} from "../../../services/translation.service";
import { Router } from '@angular/router';


@Component({
  selector: 'app-remove-podcast',
  templateUrl: './remove-podcast.component.html',
  styleUrls: ['./remove-podcast.component.css']
})
export class RemovePodcastComponent implements OnInit {

    @Input() podcastItem:PodcastItem;
    modalRef: BsModalRef;

    constructor(
        private bsModalRef: BsModalRef,
        private http: HttpClient,
        private router: Router,
        private modalService: BsModalService,
        private translationService: TranslationService
    ) { }

    ngOnInit() {
    }

    close() {
        this.bsModalRef.hide()
    }

    remove() {
         const data =
         this.http
         .post('/editor/remove', {id: this.podcastItem.id} ).subscribe( (result:any) => {
                    if(result.status == 'ok'){
                        const initialState = {
                            title: this.translationService.translate('remove-podcast'),
                            type: 'success',
                            text: this.translationService.translate('remove-podcast-2')
                        };
                        this.modalRef = this.modalService.show(ModalComponent, {initialState});
                        this.close();
                        this.router.navigate(['main/my']);

                    }
            }, (error) => {
                this._handleError(error.error.message);
            });
    }


    _handleError(error) {
        const initialState = {
            title: 'Ошибка!',
            type: 'danger',
            text: error
        };
        this.modalRef = this.modalService.show(ModalComponent, {initialState});
    }


}